module.exports = __webpack_public_path__ + "img/icon-5.8e3cff43.png";